module.exports = __webpack_public_path__ + "static/img/Remember.0d597d7c.png";